import React from 'react';

import moment from 'moment';
import 'moment/locale/es';
import { Checkbox, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
const FormItem = Form.Item;

moment.locale();

class FormDesecadenantesConsulta extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let valor = this.evaluarPuntaje(values);

        let respuestas = {
          ...values,
          valor,
        };

        // console.log(this.props);
        this.props.onSubmit(respuestas);
      }
    });
  };

  evaluarPuntaje = respuestas => {
    // console.log("Entre a evaluar el puntaje con....");
    // console.log(respuestas);

    let valor = 0;
    //Lo que busco a continuacion es sumar los valores, pero como estan en STRINGS, primero debo aplicar el operador UNARIO + para convertirlos a INT.

    if (respuestas.hijosGrandes) {
      valor = valor + 0;
    }

    if (respuestas.golpesHijos) {
      valor = valor + 3;
    }

    if (respuestas.conocimientoEnOtros) {
      valor = valor + 0;
    }

    if (respuestas.adulterioInfidelidad) {
      valor = valor + 1;
    }

    if (respuestas.porSolicitudDeHijo) {
      valor = valor + 2;
    }

    if (respuestas.seSienteEnSituacionLimite) {
      valor = valor + 3;
    }

    if (respuestas.tuvoMiedo) {
      valor = valor + 3;
    }

    if (respuestas.razonesLegalesOJuridicas) {
      valor = valor + 1;
    }

    if (respuestas.porDecisionDeOtro) {
      valor = valor + 2;
    }

    // console.log("El resultado es.... ", valor);

    return valor;
  };

  render() {
    moment.locale();
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Desecadenantes de la Consulta</h1>

        <Form onSubmit={this.handleSubmit} className="formulariosViolencia">
          <FormItem {...formItemLayout} label="Hijos grandes/independientes">
            {getFieldDecorator('hijosGrandes', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Golpes a los hijos">
            {getFieldDecorator('golpesHijos', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Conocimiento del problema en otros/as"
          >
            {getFieldDecorator('conocimientoEnOtros', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Adulterio o Infidelidad">
            {getFieldDecorator('adulterioInfidelidad', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Por solicitud de un hijo/a">
            {getFieldDecorator('porSolicitudDeHijo', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Se siente en una situacion limite"
          >
            {getFieldDecorator('seSienteEnSituacionLimite', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Tuvo miedo (mas que el habitual)"
          >
            {getFieldDecorator('tuvoMiedo', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Razones legales o juridicas">
            {getFieldDecorator('razonesLegalesOJuridicas', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Por decisión de otro">
            {getFieldDecorator('porDecisionDeOtro', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button style={{ margin: 10 }} type="primary" htmlType="submit">
              Siguiente
            </Button>
            <Button
              style={{ margin: 10 }}
              type="danger"
              onClick={this.props.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormDesecadenantesConsulta);
